export class BettingTypeSetting {
    bettingTypeId: string;
    isLive: boolean;
    sortOrder: number;
    sortOrderCashRegister: number;
}